import { billOfMaterialsIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";
import { null as zNull } from "zod";

export const BomListItemSchema = z.object({
  id: billOfMaterialsIdFormat.schema,
  name: z.string(),
  tags: z.array(z.string()).optional(),
});

export type BomListItem = z.infer<typeof BomListItemSchema>;

export const getBoms = {
  name: "getBoms" as const,
  input: zNull(),
  output: z.object({ boms: z.array(BomListItemSchema) }),
};
